import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=61d138ad&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=js"
export * from "./OrderDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=61d138ad&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d138ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61d138ad')) {
      api.createRecord('61d138ad', component.options)
    } else {
      api.reload('61d138ad', component.options)
    }
    module.hot.accept("./OrderDetail.vue?vue&type=template&id=61d138ad&scoped=true", function () {
      api.rerender('61d138ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/hotelOrder/components/OrderDetail.vue"
export default component.exports